"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var browser_core_1 = require("@datadog/browser-core");
exports.Datacenter = browser_core_1.Datacenter;
var rum_entry_1 = require("./rum.entry");
exports.datadogRum = rum_entry_1.datadogRum;
var rum_1 = require("./rum");
exports.RumEventCategory = rum_1.RumEventCategory;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@datadog/browser-rum/cjs/index.js
// module id = 19
// module chunks = 0